var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "login-container" }, [
    _c("div", { staticClass: "login-form" }, [
      _c("div", { staticClass: "card" }, [
        _c("div", { staticClass: "card-header" }, [
          _vm._m(0),
          _vm._v(" "),
          _c("div", { staticClass: "text-login" }, [
            _vm._v(_vm._s(_vm.$t("general.system_name")))
          ])
        ]),
        _vm._v(" "),
        _c(
          "form",
          {
            on: {
              submit: function($event) {
                $event.preventDefault()
                return _vm.handleSubmit.apply(null, arguments)
              }
            }
          },
          [
            _c("div", { staticClass: "card-body" }, [
              _vm.errorMessage
                ? _c("div", { staticClass: "error-message" }, [
                    _c("div", { staticClass: "d-flex" }, [
                      _vm._m(1),
                      _vm._v(" "),
                      _c("div", { staticClass: "errror-txt" }, [
                        _c("p", { staticClass: "fs-14 text-red font600" }, [
                          _vm._v(_vm._s(_vm.$t("error.title")))
                        ]),
                        _vm._v(" "),
                        _c("p", {
                          staticClass: "fs-14 text-red font600",
                          domProps: { innerHTML: _vm._s(_vm.errorMessage) }
                        })
                      ])
                    ])
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "form-box" }, [
                _c("div", { staticClass: "form-group" }, [
                  _c("div", { staticClass: "form-input" }, [
                    _c("i", { staticClass: "icon-left icon-user" }),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.username,
                          expression: "username"
                        },
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: "required",
                          expression: "'required'"
                        }
                      ],
                      staticClass: "form-control",
                      attrs: {
                        type: "text",
                        placeholder: _vm.$t("login.user_name"),
                        name: "username",
                        "data-vv-as": _vm.$t("login.user_name"),
                        inputmode: "email",
                        autocapitalize: "off"
                      },
                      domProps: { value: _vm.username },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.username = $event.target.value
                        }
                      }
                    })
                  ]),
                  _vm._v(" "),
                  _vm.errors.has("username")
                    ? _c("span", { staticClass: "error-text" }, [
                        _vm._v(_vm._s(_vm.errors.first("username")))
                      ])
                    : _vm._e()
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "form-group" }, [
                  _c("div", { staticClass: "form-input" }, [
                    _c("i", { staticClass: "icon-left icon-lock-red" }),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.password,
                          expression: "password"
                        },
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: "required",
                          expression: "'required'"
                        }
                      ],
                      staticClass: "form-control",
                      attrs: {
                        type: "password",
                        placeholder: _vm.$t("login.password"),
                        name: "password",
                        "data-vv-as": _vm.$t("login.password")
                      },
                      domProps: { value: _vm.password },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.password = $event.target.value
                        }
                      }
                    })
                  ]),
                  _vm._v(" "),
                  _vm.errors.has("password")
                    ? _c("span", { staticClass: "error-text" }, [
                        _vm._v(_vm._s(_vm.errors.first("password")))
                      ])
                    : _vm._e()
                ]),
                _vm._v(" "),
                _c("details", [
                  _c("summary", [
                    _vm._v(_vm._s(_vm.$t("login.place_id_show")))
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-group" }, [
                    _c("div", { staticClass: "form-input" }, [
                      _c("i", { staticClass: "icon-left icon-zipcode" }),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.placeId,
                            expression: "placeId"
                          },
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "digits:4",
                            expression: "'digits:4'"
                          }
                        ],
                        staticClass: "form-control",
                        attrs: {
                          type: "text",
                          placeholder: _vm.$t("login.place_id"),
                          name: "placeId",
                          "data-vv-as": _vm.$t("login.place_id")
                        },
                        domProps: { value: _vm.placeId },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.placeId = $event.target.value
                          }
                        }
                      })
                    ]),
                    _vm._v(" "),
                    _vm.errors.has("placeId")
                      ? _c("span", { staticClass: "error-text" }, [
                          _vm._v(_vm._s(_vm.errors.first("placeId")))
                        ])
                      : _vm._e()
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "mt-50" }, [
                  _c("button", { staticClass: "btn btn-login" }, [
                    _vm._v(_vm._s(_vm.$t("login.login")))
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "text-center mt-3" }, [
                  _c("label", { staticClass: "checkbox-custom" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.rememberMe,
                          expression: "rememberMe"
                        }
                      ],
                      staticClass: "form-control",
                      attrs: { type: "checkbox", name: "rememberMe" },
                      domProps: {
                        checked: Array.isArray(_vm.rememberMe)
                          ? _vm._i(_vm.rememberMe, null) > -1
                          : _vm.rememberMe
                      },
                      on: {
                        change: function($event) {
                          var $$a = _vm.rememberMe,
                            $$el = $event.target,
                            $$c = $$el.checked ? true : false
                          if (Array.isArray($$a)) {
                            var $$v = null,
                              $$i = _vm._i($$a, $$v)
                            if ($$el.checked) {
                              $$i < 0 && (_vm.rememberMe = $$a.concat([$$v]))
                            } else {
                              $$i > -1 &&
                                (_vm.rememberMe = $$a
                                  .slice(0, $$i)
                                  .concat($$a.slice($$i + 1)))
                            }
                          } else {
                            _vm.rememberMe = $$c
                          }
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("span", { staticClass: "checkmark" }),
                    _vm._v(" "),
                    _c("span", { staticClass: "lb-" }, [
                      _vm._v(_vm._s(_vm.$t("login.remember_me")))
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "mt-3" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-pink-44 w-100 ex-orange-light",
                      on: {
                        click: function($event) {
                          return _vm.setChangePass(true)
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n                                " +
                          _vm._s(_vm.$t("login.change_password")) +
                          "\n                            "
                      )
                    ]
                  )
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "mt-3 text-center",
                    staticStyle: { "font-size": "14px" }
                  },
                  [
                    _vm._v(
                      "\n                            パスワードが分からない場合は"
                    ),
                    _c("br"),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        attrs: { href: _vm.$t("chatbot.url"), target: "_blank" }
                      },
                      [_vm._v("証憑類電子化チャットボット")]
                    ),
                    _vm._v("へ\n                        ")
                  ]
                )
              ])
            ])
          ]
        )
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("a", { staticClass: "logo-link", attrs: { href: "#" } }, [
      _c("img", {
        attrs: { src: require("@/assets/img/logo_jtb.png"), alt: "Logo" }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [_c("i", { staticClass: "icon-warning mr-1" })])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-02ddf6c0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-02ddf6c0","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/components/sp/Login/Login.vue
// module id = null
// module chunks = 